import { css } from 'emotion';
import { kebabCase } from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

const wrapper = (className: string) => css`
  ${className}
  position: relative;
  padding-top: 10px;
`;

const focusedLabel = css`
  transform: scale(0.9) translateY(-27px) translateX(-16px);
  background: #ffffff;
  padding: 0 10px;
`;

const input = (labelId: string) => css`
  box-sizing: border-box;
  width: 100%;
  height: 50px;

  font-family: 'Nunito', sans-serif;
  font-size: 16px;

  border: solid 1px #bfbcbc;
  border-radius: 25px;
  padding-left: 40px;

  outline: none;

  -webkit-appearance: none;

  &:focus {
    & + #${labelId} {
      ${focusedLabel}
    }
  }
`;

const label = (value: string) => css`
  position: absolute;
  font-size: 15px;

  cursor: text;

  left: 41px;
  top: 25px;

  color: #9e9e9e;

  transition: 0.25s ease-in-out;

  ${value && focusedLabel}
`;

const error = (errorValue?: string) => css`
  box-sizing: border-box;
  background: #ffc530;
  width: 100%;
  position: absolute;
  bottom: 70px;

  z-index: 2;

  min-height: 22px;

  padding: 10px 27px;
  border-radius: 25px;

  font-size: 15px;

  ${errorValue ? 'opacity: 1;' : 'opacity: 0;'}

  transition: 0.2s ease-in-out;

  &::after {
    content: '';
    position: absolute;
    bottom: -7px;
    right: 23px;

    height: 15px;
    width: 15px;
    transform: rotate(45deg);

    background: #ffc530;
  }
`;

interface IInputProps {
  className?: string;
  name?: string;
  value?: string;
  errorValue?: string;
  maxLength?: number;
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
}

export const Input = observer(
  ({ name = '', value = '', className = '', maxLength, errorValue, onChange }: IInputProps) => {
    const id = kebabCase(name);

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
      if (maxLength && e.target.value.length <= maxLength) {
        onChange && onChange(e); // tslint:disable-line
      }
    }

    return (
      <div className={wrapper(className)}>
        <div className={error(errorValue)}>{errorValue}</div>
        <input onChange={handleChange} autoComplete="off" id={id} className={input(id)} value={value} />
        <label id={id} htmlFor={id} className={label(value)}>
          {name}
        </label>
      </div>
    );
  },
);
